// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .sizing-group {
  padding: 24px 34px;
}
.presize-root .sizing-group.is-hidden {
  display: none;
}
.presize-root .sizing-group .tags {
  margin-left: 16px;
  font-weight: normal;
}
.presize-root .sizing-group .tags .ant-tag {
  border: none;
}
.presize-root .sizing-group .tags .tag-purple {
  background-color: #e0cdf2;
  color: #6022bb;
}
.presize-root .sizing-group .tags .tag-red {
  background-color: #fff1f0;
  color: #f5222d;
}
.presize-root .sizing-group .tags .tag-gold {
  background-color: #fae8c4;
  color: #8c5800;
}
.presize-root .sizing-group .tags .tag-gray {
  background-color: #efeff0;
  color: #4d4e50;
}
.presize-root .sizing-group .size-chart,
.presize-root .sizing-group .size-key {
  padding: 7px 0;
  border-top: 1px solid transparent;
}
.presize-root .sizing-group .size-chart .ant-select,
.presize-root .sizing-group .size-key .ant-select {
  width: 100%;
}
.presize-root .sizing-group .title-separator:before {
  content: '·';
  margin: 0 8px;
}
.presize-root .sizing-group > .ant-row:not(:nth-child(2)) .matrix-1d .ant-table-container {
  border-top: none;
  border-radius: 0;
}
.presize-root .sizing-group .sizing {
  margin-top: 8px;
}
.presize-root .sizing-group .sizing,
.presize-root .sizing-group .sizing .ant-table,
.presize-root .sizing-group .sizing .ant-table td {
  transition: background 0.3s;
}
.presize-root .sizing-group .sizing:hover,
.presize-root .sizing-group .sizing:hover .ant-table,
.presize-root .sizing-group .sizing:hover td {
  background: #fafafa;
}
.presize-root .sizing-group .sizing:hover td.non-editable-cell {
  background: #fafafa;
}
.presize-root .sizing-group .flex-col {
  padding-left: 32px;
  padding-right: 32px;
  flex: 1 1 auto;
}
.presize-root .review-btn {
  text-align: right;
}
.presize-root .review-btn .ant-btn.is-reviewed:not([disabled]) {
  background-color: #75b267;
  border-style: none;
}
.presize-root .review-btn .ant-btn.is-reviewed:not([disabled]):hover {
  background-color: #2d5e27;
  color: #ffffff;
}
.presize-root .review-btn .ant-btn:hover {
  border: 1px solid #75b267;
  color: #5aa64b;
  background-color: #f0f5fe;
}
.presize-root .table {
  text-align: left;
}
.presize-root .table .ant-table-wrapper {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  width: min-content;
}
.presize-root .table table td,
.presize-root .table table th {
  text-align: right;
  width: 61px;
  padding: 4px;
}
.presize-root .table table th {
  font-weight: bold;
}
/*# sourceMappingURL=SizingGroup.css.map */`, "",{"version":3,"sources":["webpack://./SizingGroup.less","webpack://./src/components/SizingGroup/SizingGroup.less"],"names":[],"mappings":"AAAA;EAEE,kBAAA;ACAF;ADEE;EACE,aAAA;ACAJ;ADLA;EASI,iBAAA;EACA,mBAAA;ACDJ;ADTA;EAYM,YAAA;ACAN;ADZA;EAgBM,yBAAA;EACA,cAAA;ACDN;ADhBA;EAqBM,yBAAA;EACA,cAAA;ACFN;ADpBA;EA0BM,yBAAA;EACA,cAAA;ACHN;ADxBA;EA+BM,yBAAA;EACA,cAAA;ACJN;AD5BA;;EAsCI,cAAA;EACA,iCAAA;ACNJ;ADjCA;;EA0CM,WAAA;ACLN;ADrCA;EA+CI,YAAA;EACA,aAAA;ACPJ;ADzCA;EAoDI,gBAAA;EACA,gBAAA;ACRJ;AD7CA;EAyDI,eAAA;ACTJ;ADUI;;;EAGE,2BAAA;ACRN;ADWI;;;EAGE,mBAAA;ACTN;ADWI;EACE,mBAAA;ACTN;AD7DA;EA2EI,kBAAA;EACA,mBAAA;EACA,cAAA;ACXJ;ADlEA;EAkFE,iBAAA;ACbF;ADiBE;EACE,yBAAA;EACA,kBAAA;ACfJ;ADgBI;EACE,yBAAA;EACA,cAAA;ACdN;ADiBE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;ACfJ;ADlFA;EAsGE,gBAAA;ACjBF;ADrFA;EAyGI,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;ACjBJ;AD3FA;;EAiHM,iBAAA;EACA,WAAA;EACA,YAAA;AClBN;ADjGA;EAuHM,iBAAA;ACnBN;AACA,0CAA0C","sourcesContent":[".presize-root { \n .sizing-group {\n  padding: 24px 34px;\n\n  &.is-hidden {\n    display: none;\n  }\n\n  .tags {\n    margin-left: 16px;\n    font-weight: normal;\n    .ant-tag {\n      border: none;\n    }\n    // TODO remove this once RDS supports the tag colors\n    .tag-purple {\n      background-color: #e0cdf2;\n      color: #6022bb;\n    }\n\n    .tag-red {\n      background-color: #fff1f0;\n      color: #f5222d;\n    }\n\n    .tag-gold {\n      background-color: #fae8c4;\n      color: #8c5800;\n    }\n\n    .tag-gray {\n      background-color: #efeff0;\n      color: #4d4e50;\n    }\n  }\n\n  .size-chart,\n  .size-key {\n    padding: 7px 0; // Table cell height is 38px - 24px select height / 2\n    border-top: 1px solid transparent;\n\n    .ant-select {\n      width: 100%;\n    }\n  }\n\n  .title-separator:before {\n    content: '·';\n    margin: 0 8px;\n  }\n\n  > .ant-row:not(:nth-child(2)) .matrix-1d .ant-table-container {\n    border-top: none;\n    border-radius: 0;\n  }\n\n  .sizing {\n    margin-top: 8px;\n    &,\n    .ant-table,\n    .ant-table td {\n      transition: background .3s;\n    }\n\n    &:hover,\n    &:hover .ant-table,\n    &:hover td {\n      background: #fafafa;\n    }\n    &:hover td.non-editable-cell {\n      background: #fafafa;\n    }\n  }\n\n  .flex-col {\n    padding-left: 32px;\n    padding-right: 32px;\n    flex: 1 1 auto;\n  }\n}\n\n.review-btn {\n  text-align: right;\n}\n\n.review-btn .ant-btn {\n  &.is-reviewed:not([disabled]) {\n    background-color: #75b267; // fern-green-500\n    border-style: none;\n    &:hover {\n      background-color: #2d5e27;  // fern-green-900\n      color: #ffffff;\n    }\n  }\n  &:hover {\n    border: 1px solid #75b267; // fern-green-500\n    color: #5aa64b; // fern-green-600\n    background-color: #f0f5fe; // fern-green-200\n  }\n}\n\n.table {\n  text-align: left;\n  // Circumvent the whitespace at the end of each table\n  .ant-table-wrapper {\n    display: inline-block;\n    vertical-align: top;\n    font-size: 14px;\n    width: min-content;\n  }\n\n  table {\n    td, th {\n      text-align: right;\n      width: 61px;\n      padding: 4px;\n    }\n\n    th {\n      font-weight: bold;\n    }\n  }\n}\n \n}",".presize-root .sizing-group {\n  padding: 24px 34px;\n}\n.presize-root .sizing-group.is-hidden {\n  display: none;\n}\n.presize-root .sizing-group .tags {\n  margin-left: 16px;\n  font-weight: normal;\n}\n.presize-root .sizing-group .tags .ant-tag {\n  border: none;\n}\n.presize-root .sizing-group .tags .tag-purple {\n  background-color: #e0cdf2;\n  color: #6022bb;\n}\n.presize-root .sizing-group .tags .tag-red {\n  background-color: #fff1f0;\n  color: #f5222d;\n}\n.presize-root .sizing-group .tags .tag-gold {\n  background-color: #fae8c4;\n  color: #8c5800;\n}\n.presize-root .sizing-group .tags .tag-gray {\n  background-color: #efeff0;\n  color: #4d4e50;\n}\n.presize-root .sizing-group .size-chart,\n.presize-root .sizing-group .size-key {\n  padding: 7px 0;\n  border-top: 1px solid transparent;\n}\n.presize-root .sizing-group .size-chart .ant-select,\n.presize-root .sizing-group .size-key .ant-select {\n  width: 100%;\n}\n.presize-root .sizing-group .title-separator:before {\n  content: '·';\n  margin: 0 8px;\n}\n.presize-root .sizing-group > .ant-row:not(:nth-child(2)) .matrix-1d .ant-table-container {\n  border-top: none;\n  border-radius: 0;\n}\n.presize-root .sizing-group .sizing {\n  margin-top: 8px;\n}\n.presize-root .sizing-group .sizing,\n.presize-root .sizing-group .sizing .ant-table,\n.presize-root .sizing-group .sizing .ant-table td {\n  transition: background 0.3s;\n}\n.presize-root .sizing-group .sizing:hover,\n.presize-root .sizing-group .sizing:hover .ant-table,\n.presize-root .sizing-group .sizing:hover td {\n  background: #fafafa;\n}\n.presize-root .sizing-group .sizing:hover td.non-editable-cell {\n  background: #fafafa;\n}\n.presize-root .sizing-group .flex-col {\n  padding-left: 32px;\n  padding-right: 32px;\n  flex: 1 1 auto;\n}\n.presize-root .review-btn {\n  text-align: right;\n}\n.presize-root .review-btn .ant-btn.is-reviewed:not([disabled]) {\n  background-color: #75b267;\n  border-style: none;\n}\n.presize-root .review-btn .ant-btn.is-reviewed:not([disabled]):hover {\n  background-color: #2d5e27;\n  color: #ffffff;\n}\n.presize-root .review-btn .ant-btn:hover {\n  border: 1px solid #75b267;\n  color: #5aa64b;\n  background-color: #f0f5fe;\n}\n.presize-root .table {\n  text-align: left;\n}\n.presize-root .table .ant-table-wrapper {\n  display: inline-block;\n  vertical-align: top;\n  font-size: 14px;\n  width: min-content;\n}\n.presize-root .table table td,\n.presize-root .table table th {\n  text-align: right;\n  width: 61px;\n  padding: 4px;\n}\n.presize-root .table table th {\n  font-weight: bold;\n}\n/*# sourceMappingURL=SizingGroup.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
